import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';

import { LanguageSelectorComponent } from 'src/app/shared/language-selector/language-selector.component';
import { ZeffyPopupService } from 'src/app/shared/zeffy-popup.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  imports: [
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    TranslateModule,
    LanguageSelectorComponent,
  ],
})
export class NavBarComponent {
  readonly isCustomDonationPublic =
    environment.donationProvider === 'custom';

  isMenuOpen = false;

  constructor(
    private readonly translate: TranslateService,
    private readonly router: Router,
    private readonly zeffyPopupService: ZeffyPopupService
  ) { }

  ngOnInit(): void { }

  closeModalRefresh(): void {
    window.location.reload();
  }

  onDonateClick(
    event: Event
  ): void {
    if (
      this.isCustomDonationPublic
    ) {
      return;
    }

    event.preventDefault();

    this.zeffyPopupService.open();
  }

  toggleMenu(): void {
    this.isMenuOpen =
      !this.isMenuOpen;
  }

  get isDonationFlowActive(): boolean {
    const currentUrl = this.router.url;

    return (
      currentUrl.includes('(modal:donation-modal') ||
      currentUrl.startsWith('/donation-custom')
    );
  }
}